<!--
 * @Author: u0038113 yu.zhang.ca@lingyue-digital.com
 * @Date: 2023-02-14 15:33:53
 * @LastEditors: u0038113 yu.zhang.ca@lingyue-digital.com
 * @LastEditTime: 2023-02-27 10:02:31
 * @FilePath: /work/ntap/src/views/modules/rm/courseTask/aiSearch.vue
 * @Description: 智能搜索demo
-->
<template>
  <div class="ai-search-contain">
    <section class="ai-search-filter">
      <el-tabs v-model="tabType" type="border-card" class="filter-tab">
        <el-tab-pane label="自动补全" name="0">
          <el-select
            class="filter-select-input"
            v-model="name"
            filterable
            remote
            reserve-keyword
            clearable
            :placeholder="$t('contract.inputTips')"
            :remote-method="remoteMethod"
            :loading="loading">
            <el-option
              v-for="(item,index) in options"
              :key="'nameAi'+index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          <el-button class="search-button" type="primary" icon="el-icon-search" @click="searchList">搜索</el-button>
        </el-tab-pane>
        <el-tab-pane label="自动纠错" name="1">
          <el-input
            v-model="name"
            class="filter-select-input"
            :placeholder="$t('contract.inputTips')"
            @keyup.enter.native="searchList()"
            clearable
          ></el-input>
          <el-button class="search-button" type="primary" icon="el-icon-search" @click="searchList">搜索</el-button>
        </el-tab-pane>
        <el-tab-pane label="关联搜索" name="2">
          <el-input
            v-model="name"
            class="filter-select-input"
            :placeholder="$t('contract.inputTips')"
            @keyup.enter.native="searchList()"
            clearable
          ></el-input>
          <el-button class="search-button" type="primary" icon="el-icon-search" @click="searchList">搜索</el-button>
        </el-tab-pane>
        <el-tab-pane label="普通搜索" name="3">
          <el-input
            v-model="name"
            class="filter-select-input"
            :placeholder="$t('contract.inputTips')"
            @keyup.enter.native="searchList()"
            clearable
          ></el-input>
          <el-button class="search-button" type="primary" icon="el-icon-search" @click="searchList">搜索</el-button>
        </el-tab-pane>
       </el-tabs>
    </section>
    <section class="ai-search-content">
      <div v-if="errorTips" class="search-list-title">
        <span class="el-icon-question error-name"></span>已显示 “{{ name }}” 的搜索结果。仍然搜索：<span class="error-name" @click="changeSearch">{{ errorTipsName }}</span>
      </div>
      <ul class="search-list">
        <li class="search-li" v-for="item,index in dataList" :key="'searchData'+index">
          <p class="search-li-title" v-if="tabType!=='2'">{{ item.title }}</p>
          <p class="search-li-title" v-else v-html="item.title"></p>
          <p class="search-li-content">{{ item.content ? 'desc: ' + item.content : 'desc: -' }}</p>
          <p class="search-li-content"><span class="el-icon-time time-margin"></span>创建时间：{{ item.createTime }}</p>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabType: '0',
      name: '',
      options: [],
      loading: false,
      dataList: [],
      errorTipsName: '',
      errorTips: false,
      lightData: {}
    };
  },
  methods: {
    searchList () {
      this.errorTips = false;
      switch (this.tabType) {
        case '0':
          this.searchData();
          break;
        case '1':
          this.errorCheck();
          break;
        case '2':
          this.hightLightData();
          break;
        case '3':
          this.searchData();
          break;
        default:
          break;
      }
    },
    searchData () {
      const params = {
        start: 0,
        rows: 50,
        courseNameCn: this.name
      }
      this.$request.post('/learning/solr/list', params).then((res) => {
        if (res) {
          const data = res || []
          if (this.tabType === '2') {
            this.dataList = data.map((item) => {
              return { ...item, content: item.courseIntroductionCn || '', title: this.lightData[item.id] || item.courseNameCn }
            })
          } else {
            this.dataList = data.map((item) => {
              return { ...item, title: item.courseNameCn, content: item.courseIntroductionCn || '' }
            })
          }
        } 
      })
    },
    remoteMethod (query) {
      if (query) {
        this.loading = true;
        this.$request.post('/learning/solr/suggest', { keyword: query }).then((res) => {
          if (res) {
            this.options = res;
            this.loading = false;
          }
        }).catch(() => {
          this.options = [];
          this.loading = false;
        })
      }
    },
    errorCheck () {
      if (this.name) {
        this.$request.post('/learning/solr/spellcheck', { keyword: this.name }).then((res) => {
          if (res && res.length>0) {
            this.errorTipsName = this.name;
            this.name = res[0];
            this.searchData();
            this.errorTips = true;
          } else {
            this.searchData();
            this.errorTips = false;
          }
        })
      }
    },
    changeSearch () {
      this.name = this.errorTipsName;
      this.searchData();
      this.errorTips = false;
    },
    hightLightData() {
      const params = {
        keyword: this.name,
        highlightFields: ['courseNameCn'],
        highlightField: 'courseNameCn'
      }
      this.$request.post('/learning/solr/highlight', params).then((res) => {
        if (res) {
          this.lightData = res
          this.searchData()
        }
      })
    }
  },
  watch: {
    tabType() {
      this.dataList = [];
      this.errorTips = false;
      this.name = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.ai-search-contain {
  min-height: calc(100% - 120px);
  .ai-search-filter{
    background-color: #fff;
    padding: 15px;
    margin-bottom: 12px;
  }
  .ai-search-content {
    padding: 15px;
    background-color: #fff;
    .error-name {
      cursor: pointer;
      color: #409eff;
    }
    .search-list-title {
      margin-bottom: 10px;
    }
    .search-list {
      list-style: none;
      padding: 0;
      margin: 0;
      width: 80%;
      .search-li {
        padding: 20px;
        margin-bottom: 12px;
        border-radius: 5px;
        box-shadow: 0px 1px 1px #ccc,
                    0px -1px 1px #ccc;
        .search-li-title {
          font-size: 20px;
          color: #89bbef;
          margin: 0 0 10px 0;
        }
        .search-li-content {
          font-size: 12px;
          line-height: 14px;
          color: #b7b7b7;
          margin: 0 0 10px 0;
        }
        .time-margin {
          color: #409eff;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.ai-search-contain {
  .filter-select-input {
    width: 50% !important;
  }
  .el-input__inner {
    height: 34px !important;
    line-height: 34px !important;
    border-radius: 5px 0 0 5px !important;
  }
  .search-button {
    border-radius: 0 5px 5px 0 !important;
  }
}
</style>